import moment from "moment";
export const filter = {
  id: null,
  date: moment().format("DD.MM.YYYY"),  
  staff_id:'',
  created_at: '',
  updated_at: ''
};
